define.alias("shared/utils/constants/days", "settings/utils/constants/days");